export const normalizeDraftCode = (data) => {
    if (!data || typeof data !== 'object') {
        return data;
    }

    const normalized = { ...data };
    const isDraft =
        normalized?.documentState === 'Brouillon' ||
        normalized?.status === 'draft';

    if (isDraft) {
        const currentCode = normalized.code || normalized.number || '';

        if (currentCode) {
            const codeStr = String(currentCode);
            if (codeStr && !codeStr.startsWith('B-')) {
                normalized.code = `B-${codeStr}`;
            } else {
                normalized.code = codeStr;
            }
        } else {
            normalized.code = `B-TMP-${Date.now()}`;
        }
    }

    return normalized;
};

export const safeGetBillValue = (bill, key) => {
    if (!bill || typeof bill !== 'object') {
        return null;
    }

    switch (key) {
        case 'code':
            return bill.code || '';
        case 'date':
            return bill.date ? new Date(bill.date).getTime() : 0;
        case 'validity':
            return bill.validity ? new Date(bill.validity).getTime() : 0;
        case 'fullName':
            return bill.fullName || '';
        case 'reference':
            return bill.reference || '';
        case 'documentState':
            return bill.documentState || '';
        case 'totalHT':
            return bill?.totals?.rawTotal ?? 0;
        case 'totalTTC':
            return bill?.totals?.total ?? 0;
        default:
            return '';
    }
};

export const companyProfiles = {
    default: {
        profile: 'default',
        brandName: 'MYPacôme',
        name: 'CF Conciergerie',
        address: {
            street: '51 bis Avenue Aristide Briand - 1er etage',
            zipCode: '14800',
            city: 'TOUQUES',
            country: 'France'
        },
        fullAddress: '51 bis Avenue Aristide Briand - 1er etage 14800 - TOUQUES France',
        nafCode: '8299Z',
        legalForm: 'SARL',
        capital: '1000 €',
        siret: '84864867100024',
        tva: 'FR23848648671',
        bank: {
            name: 'CF CONCIERGERIE',
            iban: 'FR76 1830 6002 2536 1085 4624 186',
            bic: 'AGRIFRPP883'
        }
    },
    aveyron: {
        profile: 'aveyron',
        brandName: 'CLEAN & CARE MILLAU',
        name: 'CLEAN & CARE MILLAU',
        secondaryName: 'Clean & Care MILLAU',
        address: {
            street: '36 Avenue Jean Jaurès',
            zipCode: '12100',
            city: 'Milau',
            country: 'France'
        },
        fullAddress: '36 Avenue Jean Jaurès 12100 - Milau France',
        siret: '988 039 756 00016',
        phone: '06 58 86 44 63',
        email: 'aveyron@mypacome.fr',
        bank: {
            name: 'S.A.S. CLEAN & CARE MILLAU',
            iban: 'FR76 1120 6000 0701 3170 9612 347',
            bic: 'AGRIFRPP812'
        }
    }
};

companyProfiles.correze = {
    ...companyProfiles.default,
    profile: 'correze',
    bank: null
};

export const getCompanyInfo = () => {
    const profile = process.env.REACT_APP_COMPANY_PROFILE || 'default';
    return companyProfiles[profile] || companyProfiles.default;
};

export const companyInfo = getCompanyInfo();
